import { Directive } from '@angular/core';
import {
	AbstractControl,
	NG_VALIDATORS,
	ValidationErrors,
	Validator,
} from '@angular/forms';

@Directive({
	selector: '[xml-special-characters]',
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: XMLSpecialCharactersDirective,
			multi: true,
		},
	],
	standalone: false,
})
export class XMLSpecialCharactersDirective implements Validator {
	private regexPattern = /[&'<>"]/;

	validate(control: AbstractControl): ValidationErrors {
		return this.regexPattern.test(control.value)
			? { XMLSpecialCharacters: false }
			: null;
	}
}
